// akhila 1/12/2022 2692790263 added additionalInfo in workqueue
// akhila 1/12/2022 2692790263 added new changes in payload
// kavya9reddy 12/1/2022 2692790263 added valiadtion in workqueue
// kavya9reddy 12/1/2022 2692790263 added the select and removed autocomplete
// Sohel 12/04/2022 2692790263 Added alertPopup
// Sohel 12/13/2022 2692790263 conditionally hide Save Button
// sai Krishna 12/23/2022 2692790263 add Work Queue code, Reportcode  and Work Queue description,Report description
// Ashraf 12/27/2022 2692790263 renamed field show dashboard to show work queue list
// Raghu 12/28/2022 2692790263 Button Alignment Fixes
// kavyareddy 01/05/2023 2692790263 Fixed label issues
// sai Krishna 01/10/2023 2692790263 add auto complete
// kavyareddy 07/2/2023 2692790263 Fixed notify completion and email issue
// Sohel 02/13/2022 2692790263 roles dropdown issue
// Prakash 02/17/2023 3225736869 Added class for Multiselect Label Component.
// Prakash 02/20/2023 3225736869 Added class for Multiselect Label Component.
// Ravi 03/03/2023 3225736869 rename Report Output Format is required to Report Format type is required
// Ravi 04/03/2023 3225736869 Set Report Output Format byDefault to No
// Ravi 04/27/2023 3225736869 implement dynamic field name
// Ravi 05/10/2023 3225736869 added field in field separator validation message
// Sohel 05/24/2023 3225736869 Fixed roles and User Toast Validation Issue
// Ravi 06/15/2023 3225736869 added valueCode in field Seperator dropdown
// Sohel 06/20/2023 2700912712 Enabled Save Button
// Ravi 06/15/2023 3225736869 added show label and placeholder conditionally
// Ravi 06/15/2023 3225736869 removed by default initial value folder path and output file name
// Ravi 07/14/2023 3225736869 fixed save button disable issue
// Ravi 07/18/2023 3225736869 show work Queue Filter field Conditionally
// Ravi 07/18/2023 3225736869 fixed breadcrum code and description display issue
import {
  Button,
  FormControl,
  FormHelperText,
  TextField,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {ThemeContext} from './../../../themes/ThemeProvider';
import {SuccessSnackbar, ErrorSnackbar} from './../../../components/CustomSnackBar/index';
import PageLoader from './../../../components/PageLoader/index';
import {getOptions} from '../../../util/GetDropDownOptions';
import {getDropDownData} from './../../../redux/reducers/BRE/AddRecordFormat';
import {
  reportMasterRoleName,
  reportMasterUserName,
} from './../../../redux/reducers/BRE/AddReportMaster';
import {
  fetchBasicInfo,
  fetchWorkQueue,
  postAdditionalInfoWorkQueue,
  resetWorkQueueData,
} from './../../../redux/reducers/ReportMaster/index';
import {FILE_TYPE, FIELD_SEPERATOR} from '../../../constants/Lookup';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {WORK_QUEUE_SETUP} from '../../../constants/ReusableRoleAccess';
import BreadCrums from '../../../util/BreadCrum';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import DialogBox from '../../../components/DialogBox';
import AddFileName from '../../FrameWorks/Reports/AddReport/StepperComponents/AddFileName';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
import ReportFolderPath from '../../FrameWorks/Reports/AddReport/StepperComponents/ReportFolderPath';

const WorkQueueAdditionalInfo = ({
  handleBack,
  setTabValue,
  handleNext,
  workQueue,
  handleDirty,
  editExisting,
}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const {roleNameData, userNameData} = useSelector(({addReportMaster}) => addReportMaster);
  const classes = reusableInputStyles();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const {dropDownData} = useSelector(({addRecordFormat}) => addRecordFormat);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const {
    isLoading,
    successMsg,
    errorMsg,
    reportCode,
    addWorkQueueStatus,
    fixedlength,
    WorkQueueData,
    basicInfoData,
  } = useSelector(({reportMaster}) => reportMaster);
  const [workQueueError, setWorkQueueError] = useState(false);
  const [open, setOpen] = useState(false);
  const saveRef = useRef();
  const {roleData} = useSelector(({role}) => role);
  const [folderPath, setFolderPath] = useState(false);
  const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS;
  const getObjects = (option, typeCode) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option.toString() || item.value === option) {
          label = item;
        }
      });
    return label;
  };

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option || item.key === option || item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const options = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const handleClose = () => {
    setOpen(false);
    setFolderPath(false);
  };
  const showDashboardOptions = [
    {key: 'N', value: 'No'},
    {key: 'showSplitScreen', value: 'Show Split Screen'},
    {key: 'dontShowSplitScreen', value: 'Don\'t Show Split Screen'},
  ];

  useEffect(() => {
    if (reportCode) {
      dispatch(fetchWorkQueue(reportCode));
    }
    dispatch(getDropDownData());
    dispatch(reportMasterUserName());
    dispatch(reportMasterRoleName());
  }, []);
  const roleAccess = WorkQueueData?.displayHeader && !workQueueSetupAccess?.edit && editExisting;
  const rolesData = roleNameData?.length > 0 ? roleNameData?.map((el) => el.roleName) : [];
  const initialValues = {
    displayHeader: WorkQueueData?.displayHeader ?
      getObject(WorkQueueData?.displayHeader, options) :
      getObject('N', options),
    reportFormat:
      fixedlength === 'Y' ?
        getObjects('CSV', FILE_TYPE, dropDownData) :
        WorkQueueData?.reportFormat ?
          getObjects(WorkQueueData?.reportFormat, FILE_TYPE, dropDownData) :
          getObjects('CSV', FILE_TYPE, dropDownData),
    fieldSeparator: WorkQueueData?.fieldSeparator ?
      getObjects(WorkQueueData?.fieldSeparator, FIELD_SEPERATOR, dropDownData) :
      {valueCode: 'comma', value: ','},
    notifyCompletion:
      WorkQueueData?.notifyCompletion?.length > 0 &&
      typeof WorkQueueData?.notifyCompletion === 'object' ?
        WorkQueueData?.notifyCompletion?.join(',') :
        '',
    notifyError:
      WorkQueueData?.notifyError?.length > 0 && typeof WorkQueueData?.notifyError === 'object' ?
        WorkQueueData?.notifyError?.join(',') :
        '',
    workQueueName: WorkQueueData?.workQueueName ? WorkQueueData?.workQueueName : '',
    roles: WorkQueueData?.accessRoles?.length > 0 ? WorkQueueData?.accessRoles : [],
    user:
      WorkQueueData?.accessUsers?.length > 0 ?
        WorkQueueData?.accessUsers?.map((each) => ({userName: each})) :
        [],
    showDashboard: WorkQueueData?.showDashboard ? WorkQueueData?.showDashboard : 'N',
    showFilter: WorkQueueData?.showFilter ? WorkQueueData?.showFilter : 'N',
    genrateReportOutput: WorkQueueData?.genrateReportOutput ?
      getObject(WorkQueueData?.genrateReportOutput, options) :
      {key: 'N', value: 'No'},
    outputFileName: WorkQueueData?.reportOutputFileName ? WorkQueueData?.reportOutputFileName : '',
    reportpath: WorkQueueData?.reportfolderPath ? WorkQueueData?.reportfolderPath : '',
  };

  const schema = Yup.object().shape({
    displayHeader: Yup.mixed().test('displayHeader', 'Display Header is required', (value) => {
      if (!value) {
        return false;
      } else {
        return true;
      }
    }),
    reportFormat: Yup.mixed().test('workQueue', 'Report Format Type is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    fieldSeparator: Yup.mixed().test(
      'fieldSeparator',
      'Field Separator is required',
      (value, ctx) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      },
    ),
    notifyCompletion: Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    notifyError: Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    reportpath: Yup.mixed().test(
      'reportpath',
        `Invalid Folder path, Can't contain // and \\`,
        function(value, context) {
          const regex = /^(?!.*\\|.*\/\/).*$/;
          const {parent} = context;
          if (regex.test(parent?.reportpath)) {
            return true;
          } else {
            return false;
          }
        },
    ),
  });

  useEffect(() => {
    if (addWorkQueueStatus === 200) {
      setTimeout(() => {
        dispatch(resetWorkQueueData());
        !saveRef.current && handleNext();
      }, 2000);
    }
  }, [addWorkQueueStatus]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetWorkQueueData());
      }, 2000);
    }
  }, [errorMsg, successMsg]);
  useEffect(() => {
    if (reportCode) {
      dispatch(fetchBasicInfo(reportCode));
    }
  }, [reportCode]);

  const onSubmit = (data) => {
    if (data?.user?.length === 0 && data?.roles?.length === 0) {
      setWorkQueueError(true);
    } else {
      setWorkQueueError(false);
      dispatch(submissionStart());
      const payload = {
        accessRoles: data?.roles ? data?.roles : [],
        accessUsers: data?.user ? data?.user?.map((each) => each?.userName) : [],
        genrateReportOutput: data?.genrateReportOutput ? data?.genrateReportOutput?.key : '',
        notifyCompletion: data?.notifyCompletion.length ? data?.notifyCompletion?.split(',') : [],
        notifyError: data?.notifyError.length ? data?.notifyError?.split(',') : [],
        reportCode: basicInfoData?.reportCode ? basicInfoData?.reportCode : '',
        reportId: reportCode ? reportCode : 0,
        showDashboard: data?.showDashboard ? data?.showDashboard : 'N',
        showFilter: data?.showDashboard !== 'N' && data?.showFilter ? data?.showFilter : 'N',
        fieldSeparator: data?.fieldSeparator?.value ? data?.fieldSeparator?.value : '',
        reportFormat: data?.reportFormat?.value ? data?.reportFormat?.value : '',
        lastStep: saveRef.current ? 3 : 4,
        displayHeader: data?.displayHeader?.value ?
          data?.displayHeader?.value === 'Yes' ?
            'Y' :
            'N' :
          '',
        reportOutputFileName: data?.outputFileName ? data?.outputFileName : '',
        reportfolderPath: data?.reportpath ? data?.reportpath : '',
      };

      dispatch(postAdditionalInfoWorkQueue(payload));
    }
  };
  useEffect(() => {
    if (workQueueError) {
      setTimeout(() => {
        setWorkQueueError(false);
      }, 2500);
    }
  }, [workQueueError]);
  return (
    <>
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleBlur,
            handleChange,
            errors,
            touched,
            handleSubmit,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              {workQueue ? (
                <BreadCrums
                  name={'Work Queue Name'}
                  code={basicInfoData?.reportCode}
                  description={'Work Queue Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              ) : (
                <BreadCrums
                  name={'Report Name'}
                  code={basicInfoData?.reportCode}
                  description={'Report Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              )}
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="form-row global-field-textfields new-standard-textfields">
                  <div
                    className={`col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group autocomplete-field ${
                      values?.roles?.length > 2 && `autocomplete-checkbox`
                    }`}
                  >
                    <FormControl margin="dense" variant="outlined" fullWidth>
                      <GuiAutoComplete
                        name={'roles'}
                        id={'roles'}
                        limitTags={1}
                        size="small"
                        classes={{
                          option: classes.option,
                          listbox: classes.listBox,
                        }}
                        disableCloseOnSelect
                        getOptionSelected={(option, value) => option === value}
                        value={values?.roles?.length > 0 ? values?.roles : []}
                        multiple
                        onChange={(e, value) => {
                          if (value?.length > 0) {
                            setWorkQueueError(false);
                          }
                          handleChange(e);
                          setFieldValue('roles', value);
                        }}
                        options={rolesData}
                        autoHighlight
                        renderOption={(option, {selected}) => {
                          return (
                            <React.Fragment>
                              <>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={
                                    <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                  }
                                  checked={selected}
                                  className={classes.checkBox}
                                />
                              </>
                              {option}
                            </React.Fragment>
                          );
                        }}
                        getOptionLabel={(option) => {
                          return option;
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              className={`autocomplete-multiselect-label ${classes.labelName}`}
                              margin="dense"
                              touched={touched}
                              error={touched?.roles && errors?.roles}
                              // InputLabelProps={{ shrink: true }}
                              label={'Work Queue Roles'}
                              placeholder={`Select Work Queue Roles`}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off', // disable autocomplete and autofill
                              }}
                            />
                          </div>
                        )}
                      />
                    </FormControl>
                    <FormHelperText variant="outlined">
                      {touched?.roles && errors?.roles ? errors.roles : ''}
                    </FormHelperText>
                  </div>
                  <div
                    className={`col-sm-6 col-md-6 col-lg-4 form-group autocomplete-field ${
                      values?.user?.length > 2 && `autocomplete-checkbox`
                    }`}
                  >
                    <FormControl margin="dense" variant="outlined" fullWidth>
                      <GuiAutoComplete
                        name={'user'}
                        id={'user'}
                        size="small"
                        limitTags={1}
                        classes={{
                          option: classes.option,
                          listbox: classes.listBox,
                        }}
                        disableCloseOnSelect
                        getOptionSelected={(option, value) => option?.userName === value?.userName}
                        value={values?.user?.length > 0 ? values?.user : []}
                        multiple
                        onChange={(e, value) => {
                          if (value?.length > 0) {
                            setWorkQueueError(false);
                          }
                          handleChange(e);
                          setFieldValue('user', value);
                        }}
                        options={userNameData}
                        autoHighlight
                        renderOption={(option, {selected}) => {
                          return (
                            <React.Fragment>
                              <>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={
                                    <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                  }
                                  checked={selected}
                                  className={classes.checkBox}
                                />
                              </>
                              {option?.userName}
                            </React.Fragment>
                          );
                        }}
                        getOptionLabel={(option) => {
                          return option?.userName;
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              className={`autocomplete-multiselect-label ${classes.labelName}`}
                              margin="dense"
                              touched={touched}
                              error={touched?.user && errors?.user}
                              // InputLabelProps={{ shrink: true }}
                              label={'Work Queue Users'}
                              placeholder={`Select Work Queue Users`}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off', // disable autocomplete and autofill
                              }}
                            />
                          </div>
                        )}
                      />
                    </FormControl>
                    <FormHelperText variant="outlined">
                      {touched?.user && errors?.user ? errors.user : ''}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-6 col-md-6 col-lg-4 form-group ${classes.selectField}`}>
                    <FormControl margin="dense" variant="outlined" fullWidth className="form-group">
                      <InputLabel id="demo-simple-select-label" required>
                        Show Work Queue List
                      </InputLabel>
                      <Select
                        fullWidth
                        label="Show Work Queue List"
                        labelId="demo-simple-select-label"
                        name="showDashboard"
                        className={`select-gender ${classes.labelName}`}
                        value={values?.showDashboard ?? 'N'}
                        onChange={handleChange}
                        placeholder="Select Work Queue List"
                        onBlur={handleBlur}
                        touched={touched?.showDashboard}
                        error={Boolean(touched?.showDashboard && errors?.showDashboard)}
                      >
                        {showDashboardOptions.map((option) => {
                          return (
                            <MenuItem value={option.key} key={option.key}>
                              {option.value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormHelperText>
                      {touched?.showDashboard && errors.showDashboard && errors.showDashboard}
                    </FormHelperText>
                  </div>
                  {values?.showDashboard === 'dontShowSplitScreen' && (
                    <div className={`col-sm-6 col-md-6 col-lg-4 form-group ${classes.selectField}`}>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        className="form-group"
                      >
                        <InputLabel Id="demo-simple-select-label" required>
                          Show Work Queue Filter
                        </InputLabel>
                        <Select
                          fullWidth
                          labelId="demo-simple-select-label"
                          label=" Show Work Queue Filter"
                          name="showFilter"
                          className={`select-gender ${classes.labelName}`}
                          value={values?.showFilter ?? 'N'}
                          onChange={handleChange}
                          placeholder="Select Work Queue Filter"
                          onBlur={handleBlur}
                          touched={touched?.showFilter}
                          error={Boolean(touched?.showFilter && errors?.showFilter)}
                        >
                          {options.map((option) => {
                            return (
                              <MenuItem value={option.key} key={option.key}>
                                {option.value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <FormHelperText>
                        {touched?.showFilter && errors.showFilter && errors.showFilter}
                      </FormHelperText>
                    </div>
                  )}
                  <div className={`col-sm-6 col-md-6 col-lg-4 form-group`}>
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Notify Completion Emails"
                      margin="dense"
                      name="notifyCompletion"
                      variant="outlined"
                      value={values?.notifyCompletion}
                      label="Notify Completion Emails"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      // required
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue('notifyCompletion', e.target.value);
                      }}
                      fullWidth
                    />
                    <FormHelperText margin="dense" variant="outlined">
                      {touched?.notifyCompletion && errors?.notifyCompletion ?
                        errors?.notifyCompletion :
                        ''}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-6 col-md-6 col-lg-4 form-group`}>
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Notify Error Emails"
                      margin="dense"
                      name="notifyError"
                      variant="outlined"
                      value={values?.notifyError}
                      label="Notify Error Emails"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      // required
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue('notifyError', e.target.value);
                      }}
                      fullWidth
                    />
                    <FormHelperText margin="dense" variant="outlined">
                      {errors.notifyError ? errors.notifyError : ''}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      name="genrateReportOutput"
                      id="genrateReportOutput"
                      size="small"
                      options={options}
                      value={values.genrateReportOutput}
                      getOptionLabel={(option) => {
                        return option && option?.value;
                      }}
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('genrateReportOutput', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={`${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Generate Report Output"
                            placeholder="Select genrateReportOutput"
                          />
                        </div>
                      )}
                    />
                  </div>

                  {values?.genrateReportOutput?.key === 'Y' && (
                    <>
                      <div className="col-sm-6 col-md-6 col-lg-4 form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          id="fieldSeparator"
                          size="small"
                          value={values?.fieldSeparator}
                          autoHighlight
                          options={getOptions(FIELD_SEPERATOR, dropDownData)}
                          getOptionLabel={(option) => {
                            return option && option?.value ? option?.value : '';
                          }}
                          renderOption={(option) => {
                            return option?.value ?
                              option?.value + '  ' + `(${option?.valueCode})` :
                              '';
                          }}
                          onChange={(_, data) => {
                            setFieldValue('fieldSeparator', data);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                fullWidth
                                label="Field Separator"
                                name="fieldSeparator"
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                required
                                error={Boolean(touched.fieldSeparator && errors.fieldSeparator)}
                                placeholder="Select Field Separator"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            </div>
                          )}
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched.fieldSeparator && errors.fieldSeparator && errors.fieldSeparator}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4 form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          id="displayHeader"
                          size="small"
                          value={values?.displayHeader}
                          autoHighlight
                          options={options}
                          getOptionLabel={(option) => {
                            return option && option?.value ? option?.value : '';
                          }}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          onChange={(_, data) => {
                            setFieldValue('displayHeader', data);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                fullWidth
                                label="Display Header"
                                name="displayHeader"
                                required
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                error={Boolean(touched.displayHeader && errors.displayHeader)}
                                placeholder="Select Display Header"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            </div>
                          )}
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched.displayHeader && errors.displayHeader && errors.displayHeader}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4 form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          id="reportFormat"
                          size="small"
                          autoHighlight
                          value={values?.reportFormat}
                          options={getOptions(FILE_TYPE, dropDownData)}
                          getOptionDisabled={(option) => option?.valueCode === 'none'}
                          getOptionLabel={(option) => {
                            return option && option?.value ?
                              option?.valueCode === null ?
                                option?.value :
                                option?.valueCode + ' - ' + option?.value :
                              '';
                          }}
                          onChange={(_, data) => {
                            setFieldValue('reportFormat', data);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                fullWidth
                                label="Report Format Type"
                                error={Boolean(touched.reportFormat && errors.reportFormat)}
                                name="reportFormat"
                                required
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                placeholder="Select Report Format Type"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            </div>
                          )}
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched.reportFormat && errors.reportFormat && errors.reportFormat}
                        </FormHelperText>
                      </div>
                      <div className={`col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group py-1 reportout-filed`}>
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Work Queue Folder Path`}
                          label={'Work Queue Folder Path'}
                          multiline
                          rows={2}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                style={{cursor: 'pointer'}}
                                onClick={() => setFolderPath(true)}
                                position="start"
                              >
                                <AddBoxOutlinedIcon />
                              </InputAdornment>
                            ),
                          }}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name={'reportpath'}
                          value={values?.reportpath}
                          onChange={(e) => {
                            setFieldValue('reportpath', e.target.value);
                          }}
                          fullWidth
                          touched={touched.reportpath}
                          error={touched.reportpath && errors.reportpath}
                        />
                        <FormHelperText
                          style={{color: 'red', paddingTop: '5px'}}
                          variant="outlined"
                        >
                          {touched.reportpath && errors.reportpath && errors.reportpath}
                          {''}
                        </FormHelperText>
                      </div>
                      <div className={`col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group py-1 reportout-filed`}>
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Work Queue Output File Name`}
                          className={`${classes.labelName}`}
                          label={'Work Queue Output File Name'}
                          multiline
                          rows={2}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                style={{cursor: 'pointer'}}
                                onClick={() => setOpen(true)}
                                position="start"
                              >
                                <AddBoxOutlinedIcon />
                              </InputAdornment>
                            ),
                          }}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name={'outputFileName'}
                          value={values?.outputFileName}
                          onChange={(e) => {
                            setFieldValue('outputFileName', e.target.value);
                          }}
                          fullWidth
                          touched={touched.outputFileName}
                        />
                      </div>
                    </>
                  )}
                </div>
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  hideFooter={true}
                  maxWidth={'xl'}
                  title={'Work Queue File Name'}
                >
                  <AddFileName
                    setFieldValues={setFieldValue}
                    setOpen={setOpen}
                    addValues={values}
                    handleClose={handleClose}
                    workqueue={true}
                  />
                </DialogBox>
                <DialogBox
                  open={folderPath}
                  dialogClose={handleClose}
                  hideFooter={true}
                  maxWidth={'xl'}
                  title={'Work Queue Folder Path'}
                >
                  <ReportFolderPath
                    setFieldValues={setFieldValue}
                    setOpen={setOpen}
                    addValues={values}
                    handleClose={handleClose}
                    folderPath={folderPath}
                    workqueue={true}
                  />
                </DialogBox>
                <div className="d-flex justify-content-center mt-2 new-standard-textfields">
                  <Button
                    variant="outlined"
                    onClick={handleBack}
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {isDraftReport === "N" && ( */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 ${classes.buttonRoot}`}
                    disabled={roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = false;
                    }}
                  >
                    Save & Next
                  </Button>
                </div>
              </form>
            </>
          );
        }}
      </Formik>
      {workQueueError && <ErrorSnackbar errorMsg={'Select either roles or users'} />}
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default WorkQueueAdditionalInfo;
